<template>
    <div v-if="showAlert" class="alert alert-block alert-warning text-center">
        <button
                @click="discardAlert()"
                type="button"
                class="close">
            ×
        </button>
        <strong>🤦🏻‍️ {{'You just missed a job' | trans}} </strong>
        <RouterLink to="missed_jobs">
            <button @click="discardAlert(true)" class="btn btn-default button text-capitalize">{{'see more' | trans }}</button>
        </RouterLink>

    </div>
</template>

<script>
    import translations from '../../translations';

    export default {
    	name:"AlertMissedJobs",
        props: {},
        data() {
            return {
                conditionLanguageSelected: null,
                conditionLanguage: [
                    {value: 'fr'},
                    {value: 'nl'},
                    {value: 'en'},
                ],
                dataFromPelican: 0,
                showAlert: false
            }
        },
        mounted() {
            this.checkForMissedJobs();
        },
        methods: {
            checkForMissedJobs() {
                this.getDataPelican();
                setInterval(async () => {
                    this.getDataPelican();
                }, 15 * 60 * 1000);
            },
            async getDataPelican() {
                this.dataFromPelican = await this.$api.worker.checkMissedJobs();
                if (this.dataFromPelican.success && this.dataFromPelican.data > 0 && this.$route.name !== 'missed_jobs') {
                    this.showAlert = true;
                }
            },
            discardAlert(route = false) {
                if (!route) {
                    this.$api.worker.readMissedJobs();
                }
                this.showAlert = false;
            }
        },
        computed: {},
        components: {}
    }

</script>

<style scoped>
</style>
